<template>
  <tci-solution subtitle="" :title="$t('solution.crm.title')" :images='$i18n.locale=="zh"?infos:infos_ja' :infos="$t('solution.crm.info')"></tci-solution>
</template>

<script>
import TciSolution from "@/components/TciSolution.vue";

export default {
  name: "CompanyService",
  components: {
    "tci-solution": TciSolution
  },
  data: () => ({
    infos: [
        {"imageUrl":require('../assets/solution/s2-0.jpg'),"title":""},
        {"imageUrl":require('../assets/solution/s2-1.jpg'),"title":"产品特色&我们的服务"},
        {"imageUrl":require('../assets/solution/s2-2.jpg'),"title":"使用场景"},
        {"imageUrl":require('../assets/solution/s2-3.jpg'),"title":"产品示意图（移动端）"},
        {"imageUrl":require('../assets/solution/s2-4.jpg'),"title":"实施案例"}
    ],
    infos_ja: [
        {"imageUrl":require('../assets/solution/s2-0-ja.jpg'),"title":""},
        {"imageUrl":require('../assets/solution/s2-1-ja.jpg'),"title":"製品の特長＆弊社のサービス"},
        {"imageUrl":require('../assets/solution/s2-2-ja.jpg'),"title":"適用シーン"},
        {"imageUrl":require('../assets/solution/s2-3-ja.jpg'),"title":"製品イメージ図（移動端末）"},
        {"imageUrl":require('../assets/solution/s2-4-ja.jpg'),"title":"実施案件"}
    ]
  })
};
</script>
